import { GroupBase } from 'react-select';

import type { IOptionItem } from '@wyz/types';
import {
  PublicTypeAheadFieldProps,
  TypeaheadField as BaseTypeaheadField,
} from '@wyz/ui';
import { Trans } from '~/common/context';

function TypeaheadField<
  IsMulti extends boolean,
  Option extends IOptionItem = IOptionItem,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: Omit<PublicTypeAheadFieldProps<IsMulti, Option, Group>, 'Trans'>) {
  return <BaseTypeaheadField {...props} Trans={Trans} />;
}

export default TypeaheadField;
